import axios from "axios";
export async function getCategories(assessment: string) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/assessment/"+assessment+"/categories");
    return response.data;
}

export async function searchControl(assessment: string, search: string) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/assessment/"+assessment+"/search-control/"+search);
    return response.data;
}


export async function getCompleted(assessment: string) {
    let response = await axios.get(process.env.REACT_APP_WISEVIEW_BACKEND_URL+ "/assessment/"+assessment+"/completed");
    return response.data;
}
